<template>
  <v-card class="mx-auto" min-height="50">
    <div class="my-2">
      <v-row dense>
        <v-col class="px-5" cols="10">
          <h3>Estatística - Orçamentos</h3>
        </v-col>
        <v-col cols="2">
          <v-btn @click="ativaCardEstatisticas" color="primary" fab small dark absolute right>
            <v-icon>mdi-chart-bar</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-card v-if="cardEstatisticas" class="mx-auto" min-height="50">
      <v-container fluid>
        <v-row dense>
          <v-col cols="6">
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Orçamentos - Canal/Valor</h4>
                  <PieChart v-bind:estatisticas=" estatisticaOrcCanalStore[1]" />
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="200" max-height="300">
                  <v-simple-table dense>
                    <thead>
                      <th class="text-left">Canal</th>
                      <th class="text-right">Qtde</th>
                      <th class="text-right">Custo</th>
                      <th class="text-right">Venda</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in estatisticaOrcCanalStore[2]" :key="item[0]">
                        <td class="caption">{{ item.canalCaptacao }}</td>
                        <td class="text-right caption">{{ item.qtde }}</td>
                        <td class="text-right caption">{{ item.custo | dinheiro}}</td>
                        <td class="text-right caption">{{ item.valor | dinheiro}}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>         
          <v-col cols="6">
            <v-row dense>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Orçamentos - Loja/Qtde</h4>
                  <PieChart v-bind:estatisticas="estatisticaOrcLojaStore[0]" />
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Orçamentos - Loja/Valor</h4>
                  <PieChart v-bind:estatisticas="estatisticaOrcLojaStore[1]" />
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="200" max-height="300">
                  <v-simple-table dense>
                    <thead>
                      <th class="text-left">Loja</th>
                      <th class="text-right">Qtde</th>
                      <th class="text-right">Custo</th>
                      <th class="text-right">Venda</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in estatisticaOrcLojaStore[2]" :key="item[0]">
                        <td class="caption">{{ item.cdfil }}</td>
                        <td class="text-right caption">{{ item.qtde }}</td>
                        <td class="text-right caption">{{ item.custo | dinheiro }}</td>
                        <td class="text-right caption">{{ item.venda | dinheiro }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-row dense>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Orçamentos - Cliente/Qtde</h4>
                  <PieChart v-bind:estatisticas="estatisticaOrcTipoClienteStore[0]" />
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Orçamentos - Cliente/Valor</h4>
                  <PieChart v-bind:estatisticas="estatisticaOrcTipoClienteStore[1]" />
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="110" max-height="300">
                  <v-simple-table dense>
                    <thead>
                      <th class="text-left">Tipo</th>
                      <th class="text-right">Qtde</th>
                      <th class="text-right">Custo</th>
                      <th class="text-right">Venda</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in estatisticaOrcTipoClienteStore[2]" :key="item[0]">
                        <td class="caption">{{ item.tipoCliente }}</td>
                        <td class="text-right caption">{{ item.qtde }}</td>
                        <td class="text-right caption">{{ item.custo | dinheiro }}</td>
                        <td class="text-right caption">{{ item.valor | dinheiro }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row dense>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Orçamentos - Status/Qtde</h4>
                  <PieChartCustom v-bind:estatisticas="estatisticaOrcStatusStore[0]" />
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card min-height="250" max-height="250">
                  <h4 class="text-center">Orçamentos - Status/Valor</h4>
                  <PieChartCustom v-bind:estatisticas="estatisticaOrcStatusStore[1]" />
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card min-height="110" max-height="300">
                  <v-simple-table dense>
                    <thead>
                      <th class="text-left">Aprovado</th>
                      <th class="text-right">Qtde</th>
                      <th class="text-right">Custo</th>
                      <th class="text-right">Venda</th>
                    </thead>
                    <tbody>
                      <tr v-for="item in estatisticaOrcStatusStore[2]" :key="item[0]">
                        <td class="caption">{{ item.aprovado }}</td>
                        <td class="text-right caption">{{ item.qtde }}</td>
                        <td class="text-right caption">{{ item.custo | dinheiro }}</td>
                        <td class="text-right caption">{{ item.valor | dinheiro }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-card>
</template>

<script>
import PieChart from "../components/charts/PieChart";
import PieChartCustom from "../components/charts/PieChartCustom";
import { mapGetters } from "vuex";

export default {
  components: {
    PieChart,
    PieChartCustom
  },
  data: () => ({
    cardEstatisticas: false
  }),
  computed: {
    ...mapGetters({
      estatisticaOrcLojaStore: "estatisticaOrcamentosPorLoja",
      estatisticaOrcCanalStore: "estatisticaOrcamentosPorCanal",
      estatisticaOrcTipoClienteStore: "estatisticaOrcamentosPorTipoCliente",
      estatisticaOrcStatusStore: "estatisticaOrcamentosPorStatus"
    })
  },
  methods: {
    ativaCardEstatisticas() {
      if (this.cardEstatisticas === false) {
        this.cardEstatisticas = true;
      } else {
        this.cardEstatisticas = false;
      }
    }
  }
};
</script>

<style>
</style>